import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { EASE } from "./Reveal";

export const EditorialCard = ({
  image,
  imageAlt,
  icon: Icon,
  category,
  title,
  description,
  ctaLabel = "Explore",
  onCta,
  to,
  testId,
  delay = 0,
  static: isStatic = false,
}) => (
  <motion.article
    data-testid={testId}
    className={`group relative flex flex-col border border-[rgba(200,164,93,0.22)] bg-[#0D0D0D] transition-[transform,border-color,box-shadow] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1.5 hover:border-[rgba(200,164,93,0.5)] hover:shadow-[0_18px_60px_rgba(177,138,68,0.13)] ${
      isStatic ? "min-w-0" : "min-w-[82%] sm:min-w-[58%] lg:min-w-0"
    }`}
    initial={{ opacity: 0, y: 34 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    <div className="relative aspect-[4/3] overflow-hidden">
      <img
        src={image}
        alt={imageAlt || title}
        loading="lazy"
        className="img-lux-grade h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.045]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-[#0D0D0D]/10 to-transparent" />
    </div>
    <div className="relative flex flex-1 flex-col items-center px-7 pb-9 text-center">
      <div className="-mt-7 mb-5 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-champagne/50 bg-[#0A0A0A] shadow-[0_0_25px_rgba(200,164,93,0.12)]">
        <Icon className="h-5 w-5 text-champagne" strokeWidth={1.25} />
      </div>
      {category && (
        <p className="text-[9px] font-medium uppercase tracking-[0.32em] text-champagne/70">
          {category}
        </p>
      )}
      <h3 className="mt-2 font-serif text-[26px] font-medium leading-snug text-ivory">{title}</h3>
      <p className="mt-3 text-[13px] font-light leading-relaxed text-ivory-muted">{description}</p>
      {to ? (
        <Link
          to={to}
          data-testid={`${testId}-cta`}
          className="mt-auto inline-flex items-center gap-3 pt-6 text-[10px] font-medium uppercase tracking-[0.3em] text-champagne transition-colors duration-300 hover:text-champagne-light"
        >
          {ctaLabel}
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-[5px]" strokeWidth={1.5} />
        </Link>
      ) : (
        <button
          type="button"
          onClick={onCta}
          data-testid={`${testId}-cta`}
          className="mt-auto inline-flex items-center gap-3 pt-6 text-[10px] font-medium uppercase tracking-[0.3em] text-champagne transition-colors duration-300 hover:text-champagne-light"
        >
          {ctaLabel}
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-[5px]" strokeWidth={1.5} />
        </button>
      )}
    </div>
  </motion.article>
);
